import { EmptyRegisters } from "../entities/registers";
import { MinerAddressMainnet, MinerAddressTestnet } from "../constants";
import { ergoTreeFromAddress } from "../entities/ergoTree";
export class DefaultTxAssembler {
    constructor(mainnet) {
        this.mainnet = mainnet;
    }
    assemble(req, ctx) {
        let change = req.inputs.change;
        let changeBox = change
            ? [
                {
                    value: change.value,
                    ergoTree: ergoTreeFromAddress(req.changeAddress),
                    creationHeight: ctx.height,
                    assets: change.assets,
                    additionalRegisters: EmptyRegisters
                }
            ]
            : [];
        let feeBox = req.feeNErgs
            ? [
                {
                    value: req.feeNErgs,
                    ergoTree: ergoTreeFromAddress(this.mainnet ? MinerAddressMainnet : MinerAddressTestnet),
                    creationHeight: ctx.height,
                    assets: [],
                    additionalRegisters: EmptyRegisters
                }
            ]
            : [];
        let outputs = [...req.outputs, ...changeBox, ...feeBox];
        return {
            inputs: req.inputs.unsignedInputs,
            dataInputs: req.dataInputs,
            outputs: outputs
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHhBc3NlbWJsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXJnby93YWxsZXQvdHhBc3NlbWJsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsT0FBTyxFQUFDLGNBQWMsRUFBQyxNQUFNLHVCQUF1QixDQUFBO0FBQ3BELE9BQU8sRUFBQyxtQkFBbUIsRUFBRSxtQkFBbUIsRUFBQyxNQUFNLGNBQWMsQ0FBQTtBQUNyRSxPQUFPLEVBQUMsbUJBQW1CLEVBQUMsTUFBTSxzQkFBc0IsQ0FBQTtBQU14RCxNQUFNLE9BQU8sa0JBQWtCO0lBQzdCLFlBQTRCLE9BQWdCO1FBQWhCLFlBQU8sR0FBUCxPQUFPLENBQVM7SUFBRyxDQUFDO0lBRWhELFFBQVEsQ0FBQyxHQUFjLEVBQUUsR0FBbUI7UUFDMUMsSUFBSSxNQUFNLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUE7UUFDOUIsSUFBSSxTQUFTLEdBQUcsTUFBTTtZQUNwQixDQUFDLENBQUM7Z0JBQ0U7b0JBQ0UsS0FBSyxFQUFFLE1BQU0sQ0FBQyxLQUFLO29CQUNuQixRQUFRLEVBQUUsbUJBQW1CLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQztvQkFDaEQsY0FBYyxFQUFFLEdBQUcsQ0FBQyxNQUFNO29CQUMxQixNQUFNLEVBQUUsTUFBTSxDQUFDLE1BQU07b0JBQ3JCLG1CQUFtQixFQUFFLGNBQWM7aUJBQ3BDO2FBQ0Y7WUFDSCxDQUFDLENBQUMsRUFBRSxDQUFBO1FBQ04sSUFBSSxNQUFNLEdBQUcsR0FBRyxDQUFDLFFBQVE7WUFDdkIsQ0FBQyxDQUFDO2dCQUNFO29CQUNFLEtBQUssRUFBRSxHQUFHLENBQUMsUUFBUTtvQkFDbkIsUUFBUSxFQUFFLG1CQUFtQixDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDLENBQUMsQ0FBQyxtQkFBbUIsQ0FBQztvQkFDdkYsY0FBYyxFQUFFLEdBQUcsQ0FBQyxNQUFNO29CQUMxQixNQUFNLEVBQUUsRUFBRTtvQkFDVixtQkFBbUIsRUFBRSxjQUFjO2lCQUNwQzthQUNGO1lBQ0gsQ0FBQyxDQUFDLEVBQUUsQ0FBQTtRQUNOLElBQUksT0FBTyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUMsT0FBTyxFQUFFLEdBQUcsU0FBUyxFQUFFLEdBQUcsTUFBTSxDQUFDLENBQUE7UUFDdkQsT0FBTztZQUNMLE1BQU0sRUFBRSxHQUFHLENBQUMsTUFBTSxDQUFDLGNBQWM7WUFDakMsVUFBVSxFQUFFLEdBQUcsQ0FBQyxVQUFVO1lBQzFCLE9BQU8sRUFBRSxPQUFPO1NBQ2pCLENBQUE7SUFDSCxDQUFDO0NBQ0YifQ==